import { BrowserUtils } from "@azure/msal-browser";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { SharedModule } from "./shared/shared.module";

import { RoleGuard } from "./auth/guards/Role.guard";
import { MsalGuard } from "@azure/msal-angular";

// components
import { CalendarMainPageComponent } from "./calendar/pages/main/calendar-main-page/calendar-main-page.component";
import { HomeAttendanceComponent } from "./attendanceRecord/pages/home-attendance/home-attendance.component";
import { HomeComponent } from "./components/home/home.component";
import { LoginComponent } from "./components/login/login.component";
import { MenubarComponent } from "./shared/menubar/menubar.component";
import { NotAuthorizedComponent } from "./auth/pages/not-authorized/not-authorized.component";
import { NotFoundComponent } from "./components/not-found/not-found.component";
import { ThanYouPageComponent } from "./attendanceRecord/pages/than-you-page/than-you-page.component";
import { roleIdByName } from "./auth/constants/auth.constants";
import { MyQrsMainPageComponent } from "./misQr/pages/my-qrs-main-page/my-qrs-main-page.component";
import { ModalShareQrAttendanceComponent } from "./misQr/components/modal-share-qr-attendance/modal-share-qr-attendance.component";

const routes: Routes = [
  {
    path: "registrarAsistencia",
    component: HomeAttendanceComponent,
  },
  {
    path: "forbidden",
    component: NotAuthorizedComponent,
  },
  {
    path: "thankYouPage",
    component: ThanYouPageComponent,
  },
  {
    path: "login",
    component: LoginComponent,
  },
  // Protected Routes
  {
    path: "",
    component: MenubarComponent,
    canActivate: [MsalGuard],
    children: [
      {
        path: "home",
        component: HomeComponent,
        canActivate: [MsalGuard],
      },
      {
        path: "myQrs",
        component: MyQrsMainPageComponent,
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [
            roleIdByName.instructor,
            roleIdByName.jefeDesarrollo,
            roleIdByName.oficinasNacionales,
            roleIdByName.liderNacional,
          ],
        },
      },
      {
        path: "myQrs/view-attendece/:Id",
        component: ModalShareQrAttendanceComponent,
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [
            roleIdByName.instructor,
            roleIdByName.jefeDesarrollo,
            roleIdByName.oficinasNacionales,
            roleIdByName.liderNacional,
          ],
        },
      },
      {
        path: "report-assistance",
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [
            roleIdByName.instructor,
            roleIdByName.jefeDesarrollo,
            roleIdByName.oficinasNacionales,
            roleIdByName.liderNacional,
          ],
        },
        loadChildren: () =>
          import("./reports/reports.module").then(m => m.ReportsModule),
      },
      {
        path: "report-general",
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [
            roleIdByName.instructor,
            roleIdByName.jefeDesarrollo,
            roleIdByName.oficinasNacionales,
            roleIdByName.liderNacional,
          ],
        },
        loadChildren: () =>
          import("./general-report/report.module").then(
            m => m.GeneralReportModule
          ),
      },
      {
        path: "report-dc3",
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [
            roleIdByName.instructor,
            roleIdByName.jefeDesarrollo,
            roleIdByName.oficinasNacionales,
            roleIdByName.liderNacional,
          ],
        },
        loadChildren: () =>
          import("./dc3-report/dc3-report.module").then(m => m.Dc3ReportModule),
      },
      {
        path: "manageusers",
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [roleIdByName.oficinasNacionales],
        },
        loadChildren: () =>
          import("./manage-users/manage-users.module").then(
            m => m.ManageUsersModule
          ),
      },
      {
        path: "manageevents",
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [roleIdByName.oficinasNacionales],
        },
        loadChildren: () =>
          import("./manage-events/manage-events.module").then(
            m => m.ManageEventsModule
          ),
      },
      {
        path: "agenda",
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [
            roleIdByName.instructor,
            roleIdByName.jefeDesarrollo,
            roleIdByName.oficinasNacionales,
            roleIdByName.liderNacional,
          ],
        },
        loadChildren: () =>
          import("./agenda/agenda.module").then(m => m.AgendaModule),
      },
      {
        path: "calendar",
        component: CalendarMainPageComponent,
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [
            roleIdByName.instructor,
            roleIdByName.jefeDesarrollo,
            roleIdByName.oficinasNacionales,
            roleIdByName.liderNacional,
          ],
        },
      },
      {
        path: "catalog",
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [roleIdByName.oficinasNacionales],
        },
        loadChildren: () =>
          import("./catalog/catalog.module").then(m => m.CatalogModule),
      },
      {
        path: "config",
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [roleIdByName.oficinasNacionales],
        },
        loadChildren: () =>
          import("./admin-settings/admin-settings.module").then(
            m => m.AdminSettingsModule
          ),
      },
      {
        path: "course-planning",
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [
            roleIdByName.instructor,
            roleIdByName.jefeDesarrollo,
            roleIdByName.oficinasNacionales,
            roleIdByName.liderNacional,
          ],
        },
        loadChildren: () =>
          import("./course-planning/course-planning.module").then(
            m => m.CoursePlanningModule
          ),
      },
      /*
      // SIFCA V4.0

      {
        path: "request-management",
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [roleIdByName.instructor, roleIdByName.jefeDesarrollo],
        },
        loadChildren: () =>
          import("./requests-management/requests-management.module").then(
            m => m.RequestsManagementModule
          ),
      },*/
      {
        path: "deleted-sessions",
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [
            roleIdByName.instructor,
            roleIdByName.jefeDesarrollo,
            roleIdByName.oficinasNacionales,
            roleIdByName.liderNacional,
          ],
        },
        loadChildren: () =>
          import(
            "./deleted-sessions-report/deleted-sessions-report.module"
          ).then(m => m.DeletedSessionsReportModule),
      },
      {
        path: "duplicate-attendees-report",
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [roleIdByName.oficinasNacionales],
        },
        loadChildren: () =>
          import("./duplicates-report/duplicates-report.module").then(
            m => m.DuplicatesReportModule
          ),
      },
      {
        path: "traininig-report",
        canActivate: [MsalGuard, RoleGuard],
        data: {
          roles: [
            roleIdByName.instructor,
            roleIdByName.jefeDesarrollo,
            roleIdByName.oficinasNacionales,
            roleIdByName.liderNacional,
          ],
        },
        loadChildren: () =>
          import("./training-report/training-report.module").then(
            m => m.TrainingReportModule
          ),
      },
      {
        path: "",
        redirectTo: "/login",
        pathMatch: "full",
      },
      /*
  ****************************
  Esta sección del código se deshabilita a petición del cliente
  pero no se elimina por si en un futuro se necesita habilitar esta
  funcionalidad
  ****************************
  *
      {
        path: "courses",
        component: CoursesCatalogComponent,
        canActivate: [MsalGuard],
      },
      {
        path: "myCourses",
        component: CoursesCatalogComponent, // changed from MyCoursesCatalogComponent to avoid code duplication and keep everything in one module
        canActivate: [MsalGuard],
      },
      */
    ],
  },

  {
    path: "",
    redirectTo: "/login",
    pathMatch: "full",
  },
  { path: "**", component: NotFoundComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      useHash: true,
      onSameUrlNavigation: "reload",
      // Don't perform initial navigation in iframe or popups
      initialNavigation:
        !BrowserUtils.isInIframe() && !BrowserUtils.isInPopup()
          ? "enabledNonBlocking"
          : "disabled", // Set to enabledBlocking to use Angular Universal
    }),
    SharedModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
